import { NodeType } from "../types";
import Link from "./link";
import { floatToFixedIfNeeded } from "../utils";

export default class Node {
  name: string;
  weight: number;
  x: number;
  y: number;
  paths: Link[];
  constructor(options: NodeType) {
    this.name = options.name;
    this.weight = options.weight || 50;
    this.x = options.x;
    this.y = options.y;
    this.paths = [];
  }

  insertPath(path: Link): void {
    if (this.paths.some((p) => p.toNodeName === path.toNodeName)) return;
    if (this.name === path.toNodeName) return;

    this.paths.push(path);
  }

  removeLink(toNodeName: string): void {
    this.paths = this.paths.filter((link) => link.toNodeName !== toNodeName);
  }

  move(diffX: number, diffY: number): void {
    this.x += diffX;
    this.y += diffY;
  }

  toString(): string {
    const x = floatToFixedIfNeeded(this.x);
    const y = floatToFixedIfNeeded(this.y);
    const weight = floatToFixedIfNeeded(this.weight);
    return `${this.name} (${x}, ${y}) ${weight} u.`;
  }

  toJSON(): NodeType {
    return {
      name: this.name,
      weight: this.weight,
      x: this.x,
      y: this.y,
    };
  }
}
